import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AudioList from "./AudioList";
import  CreateAudioWizard  from "./CreateAudioWizard/CreateAudioWizard";

const AudioPage = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`} component={CreateAudioWizard} />
            <Route path={`${path}/:audioId/wizard`} component={CreateAudioWizard} />
            <Route default>
                <AudioList />
            </Route>
        </Switch>
    );
};

export default AudioPage;
